import { supabase } from '../../../../lib/supabase';

export const patternService = {
  async getAll() {
    const { data, error } = await supabase
      .from('patterns')
      .select('id, title, status, thumbnail_url, created_at, updated_at, pattern_data')
      .order('updated_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async getById(id) {
    const { data, error } = await supabase
      .from('patterns')
      .select('*')
      .eq('id', id)
      .single();
    if (error) throw error;
    return data;
  },

  async create(payload) {
    const { data: { user } } = await supabase.auth.getUser();
    const { data, error } = await supabase
      .from('patterns')
      .insert({ ...payload, user_id: user.id })
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async update(id, payload) {
    const { data, error } = await supabase
      .from('patterns')
      .update(payload)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async updateStatus(id, status) {
    return this.update(id, { status });
  },

  async delete(id) {
    const { error } = await supabase.from('patterns').delete().eq('id', id);
    if (error) throw error;
  },

  async uploadPhoto(patternId, file, category = 'cover') {
    const ext = file.name.split('.').pop();
    const path = `${patternId}/${category}/${Date.now()}.${ext}`;
    const { error: upErr } = await supabase.storage
      .from('pattern-photos')
      .upload(path, file, { upsert: false });
    if (upErr) throw upErr;
    const { data: { publicUrl } } = supabase.storage
      .from('pattern-photos')
      .getPublicUrl(path);
    return publicUrl;
  },

  async deletePhoto(path) {
    const { error } = await supabase.storage.from('pattern-photos').remove([path]);
    if (error) throw error;
  },
};
